module.exports = __webpack_public_path__ + "img/bg@2x.7e45fa91.png";